// extracted by mini-css-extract-plugin
export default {"checkboxList":"checkbox-list_checkboxList__+kVnI"};